module.exports = __webpack_public_path__ + "static/media/29FUNOV10.11a3d0d2.jpg";